import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import Page from "components/Page";
import styles from "../../accountpreferences.module.scss";
import "../../AccountPreference.scss";
import Text from "components/Text";
import { Card } from "reactstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import {
  encodeId,
  getStorage,
  handleError,
  handleSuccess,
  setStorage,
} from "utils";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import {
  useDeleteMessageTemplate,
  useGetMessageTemplatesList,
} from "repositories/message-templates-repository";
import useHandleApiError from "hooks/useHandleApiError";
import useRemoveCache from "hooks/useRemoveCache";
import constants from "./../../../../constants";
import Empty from "components/Empty";
import Loader from "components/Loader";
import CustomModal from "components/CustomModal";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import NotAccessible from "accountOwner/pages/ManagerDashboard/components/NotAccessible";

const PAGE_SIZE = 4;

const MessageTemplates = ({ history, t }) => {
  const {
    ownerList: ownerData,
    commonOwnerData: selectedOwner,
    isOwner: isAccountOwner,
    selectedOwnerIdString,
    profile,
    isStaff,
    dataAccessValues,
  } = useAccountOwnerCommon();
  const isStaffCannotAccess =
    isStaff && !dataAccessValues?.isMessageTemplateModule;
    
  const cacheValue = getStorage(constants.messageTemplates.cache.list);
  const [pageNumber, setPageNumber] = useState(cacheValue?.pageNumber || 1);
  const [list, setList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);
  const {
    data,
    error: isError,
    isLoading,
    isFetching,
    refetch,
  } = useGetMessageTemplatesList(
    pageNumber,
    PAGE_SIZE,
    isAccountOwner ? profile?.id : selectedOwner?.id
  );
  const mainDivRef = useRef(null);
  const [reCalCulate, setReCalCulate] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      if (mainDivRef.current?.clientHeight) {
        setReCalCulate(true);
      }
    }, 500);
  }, []);
  const heightCalculate = useMemo(() => {
    if (isStaff && !dataAccessValues?.isAdmin && mainDivRef.current) {
      return mainDivRef.current?.clientHeight;
    }
    return 400;
  }, [dataAccessValues, isStaff, reCalCulate]);
  const deleteTemplateMutation = useDeleteMessageTemplate();
  const { isLoading: deletingTemplate } = deleteTemplateMutation;

  let totalItems = data?.pagination?.totalItems;
  useHandleApiError(isLoading, isFetching, isError);

  useEffect(() => {
    setStorage(constants.messageTemplates.cache.list, {
      pageNumber: pageNumber,
    });
  }, [pageNumber]);

  useRemoveCache([], constants.messageTemplates.cache.list);

  useEffect(() => {
    if (data?.data) {
      setList(data.data);
    }
  }, [data]);

  const goBack = () => {
    history.push(constants.routes.accountPreferences);
  };

  const handleDropDown = (itemId) => {
    const updatedList = list.map((item) => {
      if (item.id === itemId) {
        return { ...item, isDropDownOpen: !item.isDropDownOpen };
      }

      return item;
    });

    setList(updatedList);
  };
  const renderOwnerSwitcher = () => (
    <>
      {isStaff&&selectedOwner?.id && (
        <div
          className={
            "show-owner-name-text  marginBottom30"
          }
        >
              {t("accountPreferences.showingTemplates")}{" "}
              <span>
                '{selectedOwner.firstName} {selectedOwner.lastName}'
              </span>
              {t("dashBoard.office")}
            
        </div>
      )}
    </>
  );

  const renderHeader = () => (
    <div
      className={
        styles["message-templates-heading"] +
        ` d-flex justify-content-between align-items-center${(isStaff?"":" marginBottom30")}`
      }
    >
      <p className={styles["select-office"]}>
        {t("accountPreferences.messageTemplates")}
      </p>
      {isStaffCannotAccess ? (
        null
      ) : (
        <Link to={{pathname:constants.routes.accountPreference.addMessageTemplates,search:selectedOwnerIdString?`?${selectedOwnerIdString}`:""}}>
          <button className="button button-round button-shadow w-sm-100">
            {t("accountPreferences.addNewMessageTemplate")}
          </button>
        </Link>
      )}
    </div>
  );

  const renderQuickActions = (item) => (
    <Dropdown
      className="template-action"
      isOpen={item.isDropDownOpen}
      toggle={(e) => {
        e.stopPropagation();
        handleDropDown(item.id);
      }}
    >
      <DropdownToggle caret={false} tag="div">
        <span className="ico">
          <img
            src={require("assets/images/dots-icon.svg").default}
            alt="icon"
          />
        </span>
      </DropdownToggle>
      <DropdownMenu end className={styles["office-dropdown-menu"]}>
        <Fragment>
          <DropdownItem
            className={
              styles["office-dropdown-item"] + " " + "menu-hover-effect"
            }
            onClick={() => {
              editTemplate(item);
            }}
          >
            <span>{t("edit")}</span>
          </DropdownItem>
          <DropdownItem
            className={
              styles["office-dropdown-item"] + " " + "menu-hover-effect"
            }
            onClick={() => handleDelete(item)}
          >
            <span>{t("delete")}</span>
          </DropdownItem>
        </Fragment>
      </DropdownMenu>
    </Dropdown>
  );

  const viewTemplate = (e, item) => {
    e.stopPropagation();
    history.push(
{
  pathname:      constants.routes.accountPreference.viewMessageTemplates.replace(
    ":templateId",
    encodeId(item?.id)
  ),
  search:selectedOwnerIdString?`?${selectedOwnerIdString}`:""
}
    );
  };

  const handleDelete = (template) => {
    setConfirmModal(true);
    setSelectedTemplate(template);
  };

  const confirmDeleteTemplate = async (messageTemplateId) => {
    try {
      await deleteTemplateMutation.mutateAsync({
        messageTemplateId,
      });

      handleSuccess(t("accountPreferences.deleteMsg"));
      refetch();

      setConfirmModal(false);
    } catch (err) {
      handleError(err);
    }
  };

  const editTemplate = (item) => {
    history.push(
      {
        pathname:constants.routes.accountPreference.editMessageTemplates.replace(
          ":templateId",
          encodeId(item?.id)
        ),
        search:selectedOwnerIdString?`?${selectedOwnerIdString}`:""
      }
    );
  };

  const renderList = () => {
    if (isStaffCannotAccess) {
      return (
        <div
          className="not-accessible center_property"
          style={{ height: heightCalculate }}
        >
          <NotAccessible
            Message={t("dashBoard.notAccessibleModulePleaseSwitchOwner")}
          />
        </div>
      );
    }
    return (
      <>
        {!!list?.length ? (
          list.map((item) => (
            <Card
              onClick={(e) => {
                setSelectedTemplate(item);
                viewTemplate(e, item);
              }}
              className={styles["message-templates-card"] + " cursor-pointer"}
              key={item.id}
            >
              <div className={styles["schedule-update"]}>
                <Text
                  color="#587E85"
                  weight="600"
                  size="16px"
                  marginBottom="20px"
                  className={styles["schedule-update-text"]}
                >
                  {item?.templateName}
                </Text>
                {item?.creator?.id === profile?.id && renderQuickActions(item)}
              </div>
              <div>
                <div>
                  <Text color="#6F7788" weight="400" size="12px">
                    {t("messenger.createdBy")}
                  </Text>
                  <Text color="#102C42" weight="600" size="14px">
                    {item?.creator?.id === profile?.id
                      ? t("accountPreferences.you")
                      : `${item?.creator?.firstName} ${item?.creator?.lastName}`}
                  </Text>
                </div>
              </div>
            </Card>
          ))
        ) : (
          <Empty Message={t("accountPreferences.emptyMsg")} />
        )}
      </>
    );
  };

  const renderPagination = () => {
    if (isStaffCannotAccess) return null;
    return (
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          sizePerPage: PAGE_SIZE,
          totalSize: totalItems,
          page: pageNumber,
          onPageChange: setPageNumber,
        })}
      >
        {({ paginationProps, paginationTableProps }) => {
          return (
            <div className="data-table-block">
              {/* Paginator component needs table to work, this is why we have used it.  */}
              <div style={{ display: "none" }}>
                <BootstrapTable
                  keyField="id"
                  data={[]}
                  columns={[{ text: "sometext" }]}
                  {...paginationTableProps}
                />
              </div>
              <div className={"pagnation-block "}>
                {totalItems > PAGE_SIZE && (
                  <PaginationListStandalone {...paginationProps} />
                )}
              </div>
            </div>
          );
        }}
      </PaginationProvider>
    );
  };
  return (
    <>
      <Page onBack={goBack} className={styles["global-main-page"]}>
        {isLoading && <Loader />}
        <div className={styles["message-templates"]} ref={mainDivRef}>
          {renderHeader()}
          {ownerData?.length > 0 &&
isStaff&&
            renderOwnerSwitcher()}
          {renderList()}
        </div>
        {renderPagination()}
      </Page>
      {confirmModal && (
        <CustomModal
          isOpen={confirmModal}
          setIsOpen={setConfirmModal}
          actionInProgress={deletingTemplate}
          leftBtnText={t("delete")}
          rightBtnText={t("cancel")}
          title={t("accountPreferences.deleteModalTitle")}
          subTitle1={t("accountPreferences.deleteModalContent")}
          onConfirm={() => confirmDeleteTemplate(selectedTemplate.id)}
        />
      )}

    </>
  );
};

export default withTranslation()(MessageTemplates);
